import React from "react";
import { Box } from "@mui/material";
import theme from "../ThemeSettings/Theme";

function PageTop() {
  return <Box sx={{ flexShrink: 1, height: theme.spacing(4) }} />;
}

export default PageTop;
